module.exports = __webpack_public_path__ + "img/banner_2026_skin_dress_launch.3568bb65.jpg";